import { createApp } from 'vue'
import { Quasar, Dialog, Notify, Loading } from 'quasar'
import { createPinia } from 'pinia'
import { i18n, loadSavedLocale } from './i18n'
import App from './App.vue'
import router from './router'

// Import styles
import './styles/app.scss'

const app = createApp(App)
const pinia = createPinia()

app.use(Quasar, {
  plugins: {
    Dialog,
    Notify,
    Loading
  },
  config: {
    // Enable RTL support
    brand: {
      primary: '#1976D2',
      secondary: '#26A69A'
    }
  }
})
app.use(pinia)
app.use(router)
app.use(i18n)

// Load saved locale
loadSavedLocale()

app.mount('#app')